module.exports = __webpack_public_path__ + "static/media/plus.121a55a9.svg";